import { CommonMainPage } from '../../widgets/utility/CommonMainPage'
import { PpcComplianceFilters } from './widgets/ppc-compliance-filters/PpcComplianceFilters'
import { PpcComplianceTable } from './widgets/ppc-compliance-table/PpcComplianceTable'
import { useAppSelector } from '../../app/store/hooks/Redux'
import { selectProject } from './model/ppcComplianceSlice'
import { PreparingDataStub } from '../../lib/widgets/stubs/PreparingDataStub'
import { StubLayout } from '../../lib/widgets/stubs/StubLayout'
import { selectNotifications } from '../../app/store/reducers/AuthSlice'
import { AffiliateTrackingStub } from '../../lib/widgets/stubs/AffiliateTrackingStub'
import { useMemo } from 'react'
import clsx from 'clsx'

import styles from './PPCCompliancePage.module.scss'
import { useTranslation } from 'react-i18next'

export const PPCCompliancePage = () => {
  const { t } = useTranslation()
  const { value: projectId, has_paid_links: hasPaidLinks } = useAppSelector(selectProject)
  const notifications = useAppSelector(selectNotifications)

  const showTrackingStub = useMemo(() => {
    const trackingDisabled = notifications?.some(
      (value) =>
        String(value.project_id) === projectId && value.type === 'affiliate_tracking_disabled',
    )
    const trackingSetup = notifications?.some(
      (value) =>
        String(value.project_id) === projectId && value.type === 'affiliate_tracking_setup',
    )

    return trackingDisabled ? false : trackingSetup
  }, [notifications, projectId])

  return (
    <CommonMainPage
      hint={t('navigation.hint.affiliateCompliance')}
      title={t('navigation.affiliateCompliance')}
    >
      <section className={clsx(styles.wrapper)}>
        <PpcComplianceFilters />
        {showTrackingStub ? (
          <StubLayout>
            <AffiliateTrackingStub changeLocation project={projectId} />
          </StubLayout>
        ) : hasPaidLinks ? (
          <PpcComplianceTable />
        ) : (
          <StubLayout>
            <PreparingDataStub />
          </StubLayout>
        )}
      </section>
    </CommonMainPage>
  )
}
